function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 0.375C6.24219 0.375 4.69531 0.84375 3.35938 1.78125C2.09375 2.67187 1.19141 3.83203 0.652344 5.26172C0.136719 6.66797 0.0664062 8.07422 0.441406 9.48047C0.839844 11.0039 1.73047 12.293 3.11328 13.3477V16.125L5.75 14.6484C7.39062 15.0938 8.99609 15.0586 10.5664 14.543C12.1133 14.0273 13.3555 13.1602 14.293 11.9414C15.3008 10.6758 15.8047 9.24609 15.8047 7.65234C15.8047 6.33984 15.4531 5.13281 14.75 4.03125C14.0469 2.90625 13.0977 2.01563 11.9023 1.35938C10.707 0.703125 9.40625 0.375 8 0.375ZM8.80859 10.1484L6.80469 8.03906L2.9375 10.2188L7.19141 5.68359L9.19531 7.79297L13.0977 5.64844L8.80859 10.1484Z",
  fill: "currentColor"
});

var SvgFacebookMessenger = function SvgFacebookMessenger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebookMessenger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-messenger.e9dc88d6.svg";
export { ForwardRef as ReactComponent };